import { render, staticRenderFns } from "./cooperative-partner.vue?vue&type=template&id=2aa46fee&scoped=true"
import script from "./cooperative-partner.vue?vue&type=script&lang=js"
export * from "./cooperative-partner.vue?vue&type=script&lang=js"
import style0 from "./cooperative-partner.vue?vue&type=style&index=0&id=2aa46fee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa46fee",
  null
  
)

export default component.exports